<template>
  <div class="account-location">
    <el-page-header @back="$router.go(-1)" content="文案创作"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="团队文案" name="1">
        <MyCopywriting />
      </el-tab-pane>
      <el-tab-pane label="成果展示" name="2">
        <Result ref="Result" />
      </el-tab-pane>
      <el-tab-pane label="评价窗口" name="3" lazy>
        <Evaluate category="wa" />
      </el-tab-pane>
      <el-tab-pane label="英雄榜" name="4" lazy>
        <Ranking category="wa" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Evaluate from "../evaluate.vue";
import MyCopywriting from "./myCopywriting.vue";
import Ranking from "../ranking.vue";
import Result from "./result.vue";
export default {
  components: { MyCopywriting, Evaluate, Ranking, Result },
  data() {
    return {
      activeName: "1",
    };
  },
  watch: {
    activeName(val) {
      if (val == "2") this.$refs.Result.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.account-location {
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>